export default __webpack_public_path__ + "static/violins-6fc8501ad7b0c46cfb55a038edca53e7.jpg";